import { put, call, takeLatest, all } from 'redux-saga/effects';
import { processRequest } from '../../../services/Api';
import { lessonActionTypes } from './Constants';
import * as lessonActions from './Actions';
import * as errorHandlerActions from '../../../components/errorHandler/Actions';
import * as chapterDetailsActions from '../../../pagesNext/chapterDetails/Actions';
import { processTutoringRequest } from '../../shared/Constants';

export default function* () {
	yield all([
		yield takeLatest(lessonActionTypes.GET_LESSON_DETAILS_REQUEST, handleLessonDetailsRequest),
		yield takeLatest(lessonActionTypes.SEND_FEEDBACK_REQUEST, handleFeedbackRequest),
		yield takeLatest(
			lessonActionTypes.GET_SCHEDULED_LESSON_STUDENTS_REQUEST,
			handleGetScheduledLessonStudentsRequest,
		),
		yield takeLatest(
			lessonActionTypes.MANAGE_STUDENT_STATUS_REQUEST,
			handleManageStudentStatusChange,
		),
	]);
}

export function* handleLessonDetailsRequest({ payload }) {
	try {
		const { lessonId } = payload || {};
		const { data } = yield call(processTutoringRequest, `scheduled_lessons/${lessonId}`, 'GET');
		const { scheduled_lesson, error } = data;
		let chapterData = null;
		const { chapter_id, chapterIds } = scheduled_lesson || {};
		const chapterId = chapter_id || chapterIds?.[0] || null;

		if (chapterId) {
			try {
				const { data: chaptersData } = yield call(
					processRequest,
					`public/chapters/${chapterId}`,
				);
				chapterData = chaptersData;
			} catch (e) {
				yield put(errorHandlerActions.handleError(e));
				yield put(chapterDetailsActions.getChapterDetailsError());
			}
		}

		const subject = chapterData?.chapter?.subject_name || null;

		if (subject) {
			scheduled_lesson.subject = subject;
		}

		if (scheduled_lesson) {
			yield put(lessonActions.getLessonDetailsSuccess(scheduled_lesson));
		} else {
			yield put(lessonActions.getLessonDetailsError(error));
		}
	} catch (e) {
		yield put(errorHandlerActions.handleError(e));
		yield put(lessonActions.getLessonDetailsError(e));
	}
}

export function* handleFeedbackRequest({ payload }) {
	try {
		const { data: requestData, callback } = payload || {};

		const { data } = yield call(
			processTutoringRequest,
			'scheduled_lesson_feedbacks',
			'POST',
			requestData,
		);

		callback && callback();

		yield put(lessonActions.sendFeedbackSuccess(data));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e));
		yield put(lessonActions.sendFeedbackError());
	}
}

export function* handleGetScheduledLessonStudentsRequest({ payload }) {
	try {
		const { data: scheduledLessonId } = payload || {};
		const { data } = yield call(
			processTutoringRequest,
			`scheduled_lessons/${scheduledLessonId}/students`,
			'GET',
		);
		const { students, error } = data;

		if (students) {
			yield put(lessonActions.getScheduledLessonStudentsSuccess(students));
		} else {
			yield put(lessonActions.getScheduledLessonStudentsError(error));
		}
	} catch (e) {
		yield put(errorHandlerActions.handleError(e));
		yield put(lessonActions.getScheduledLessonStudentsError());
	}
}

export function* handleManageStudentStatusChange({ payload }) {
	const { status, data } = payload || {};
	const { userId, scheduled_lesson_id } = data || {};

	const ban = status === 'ban';

	const method = ban ? 'POST' : 'DELETE';

	const queries = ban ? { scheduled_lesson_id } : { user_id: userId };

	try {
		const response = yield call(
			processTutoringRequest,
			ban ? `bans` : `admin/bans`,
			method,
			queries,
		);

		const { error, success } = response || {};

		if (success) {
			yield put(lessonActions.manageStudentStatusSuccess(response));
		} else {
			yield put(lessonActions.manageStudentStatusError(error));
		}
	} catch (e) {
		yield put(errorHandlerActions.handleError(e));
		yield put(lessonActions.manageStudentStatusError(e));
	}
}
